export default __webpack_public_path__ + "static/media/11.1a2bb5c1.png";